import { Radio } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import "./appPaymentRadioButtonCSS.css";

const { Group, Button } = Radio;

const AppPaymentRadioButton = ({ options, value, onChange }) => {
  return (
    <Group onChange={onChange} value={value} className="block">
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <Button
            className="ant-radio-button-wrapper-custom"
            value={option.value}
            key={option.value}
            style={{
              display: "block",
              height: "auto",
              width: "100%",
              marginTop: "8px",
              borderRadius: "10px",
              border: `2px solid ${isSelected ? "#7b9e7e" : "#e8e8e8"}`
            }}>
            <div className="flex justify-between items-center py-2">
              <div className={`${isSelected ? "text-black" : "text-gray-500"}`}>
                <p className={`font-semibold text-lg font-poppins`}>
                  {option.label}
                </p>
                <p className="text-sm">{option.description}</p>
              </div>
              {isSelected ? (
                <div className="w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                  <CheckOutlined className="text-white" />
                </div>
              ) : (
                <div className="w-5 h-5 border-solid border-2 border-gray-200 rounded-full" />
              )}
            </div>
          </Button>
        );
      })}
    </Group>
  );
};

AppPaymentRadioButton.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default AppPaymentRadioButton;
